import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';

@Injectable({
  providedIn: 'root'
})
export class HaloUnsubscribeService {

  constructor(private httpClient: HttpClient, private httpHeaderService: HttpHeadersService) { }

  unsubscribe(data:any): Observable<any> {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/lfuser/unsubscribe?token='+data, {}, { headers});
 
   }
}
